export const ROUTE = {
  LOGIN: '/',
  GO_BACK: -1,
  FORM: 'form',
  PREVIEW: 'preview',
  TAG_LIST: 'tag-list',
  REGISTER: 'register',
  DASHBOARD: 'dashboard',
  DOC_PREVIEW: 'documents',
  TAG_DETAILS: 'tag-details',
  APP_DETAILS: 'application-details',
  GOOGLE_DOC_VIEW: 'google-doc-viewer',
};
